<app-header [isLogOutVisible]="false"></app-header>

<app-mobile-auth
  [isOnlineMode$]="isOnlineMode$ | async"
  (credentials)="mobileLoggingIn($event)"
  (displayModal)="displayModal()"
></app-mobile-auth>

<app-offline-warning-modal
  class="offline-warning"
  *ngIf="(isOnlineMode$ | async) === false && (offlineModalDisplay$ | async) === true"
  (closeClick)="onClose()"
></app-offline-warning-modal>
